import { MessageManager, SyncUiEventDispatcher } from "@itwin/appui-react";
import { NotifyMessageDetails, OutputMessagePriority, OutputMessageType } from "@itwin/core-frontend";
import { UiSyncEventArgs, RelativePosition } from "@itwin/appui-abstract";
import { BeDuration } from "@itwin/core-bentley";
import { Point2d } from "@itwin/core-geometry";

export class cMessage {
  private static _statusBarMessage: string;
  private static _statusBarIcon: string;
  private static _syncMessageList = new Map<string, any>();
  public static statusBarEventId = "cMessage.statusBarMessage";

  public static initMessage = () => {
//    this._syncMessageList = new Map<string, any>();

//    SyncUiEventDispatcher.onSyncUiEvent.clear();
    SyncUiEventDispatcher.onSyncUiEvent.addListener(this.handleSyncUiEvent);
  }

  public static showInfo = (msg: string, type: OutputMessageType = OutputMessageType.Toast) => {
    const msgDetail = new NotifyMessageDetails(OutputMessagePriority.Info, msg, undefined, type);

    msgDetail.relativePosition = RelativePosition.Right;
    msgDetail.displayTime = BeDuration.fromSeconds(2);
    msgDetail.displayPoint = Point2d.create(30, 30);

    MessageManager.outputMessage(msgDetail);
  }

  public static showStatusBarMessage = (msg: string = "", icon: string = "") => {
    this._statusBarMessage = msg;
    this._statusBarIcon = icon;

    SyncUiEventDispatcher.dispatchSyncUiEvent(this.statusBarEventId);
  }

  public static showStatusBarError = (msg: string, icon?: string) => {
    const errorIcon = icon ?? "icon-status-error-hollow";
    this.showStatusBarMessage(msg, errorIcon);
  }

  public static clearStatusBarMessage = () => {
    this.showStatusBarMessage();
  }

  public static getStatusBarMessage = (): string => {
    return this._statusBarMessage;
  }

  public static getStatusBarIcon = (): string => {
    return this._statusBarIcon;
  }

  public static setupUiEvent = (eventId: string, callback: any) => {
    this._syncMessageList.set(eventId, callback);
//    SyncUiEventDispatcher.onSyncUiEvent.addListener(callback);  //!! OA-this is wrong..
  }

  public static removeUiEvent = (eventId: string) => {
    // const callback = this._syncMessageList.get(eventId);
    // if (callback) {
    //   SyncUiEventDispatcher.onSyncUiEvent.removeListener(callback);
    // }
    this._syncMessageList.delete(eventId);
  }

  public static raiseUiEvent = (eventId: string) => {
    //    if (this._syncMessageList.get(eventId)) {
    SyncUiEventDispatcher.dispatchSyncUiEvent(eventId);
    //    }
  }

  private static handleSyncUiEvent = async (args: UiSyncEventArgs) => {
    for (const [eventId, callback] of this._syncMessageList) {
      if (args.eventIds.has(eventId)) {
        await callback();
      }
    }
  }
}
